import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'average'
})
export class AveragePipe implements PipeTransform {
  transform(items: any[], prop: string): number {
    if (!items || !items.length || !prop) return 0;
    
    if (prop.includes('/')) {
      // Handle division operations
      const [numerator, denominator] = prop.split('/');
      let sum = 0;
      let count = 0;
      
      items.forEach(item => {
        const num = this.getPropertyValue(item, numerator);
        const den = this.getPropertyValue(item, denominator);
        if (den !== 0) {
          sum += (num / den);
          count++;
        }
      });
      
      return count > 0 ? sum / count : 0;
    } else {
      // Handle regular properties
      return items.reduce((a, b) => {
        const value = this.getPropertyValue(b, prop);
        return a + (value || 0);
      }, 0) / items.length;
    }
  }

  private getPropertyValue(obj: any, path: string): number {
    return path.split('.').reduce((o, i) => o?.[i], obj) || 0;
  }
}
